import { InjectionToken, NgModule } from '@angular/core';
import { USER_PROVIDED_EFFECTS } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { getEffectTokens } from './redux/injectable-effect-tokens';

import { ReducerService } from './redux/reducer.service';
import { FEATURE_STATE, ISquirrelState } from './redux/state.interface';

const REDUCER_TOKEN = new InjectionToken<ActionReducerMap<ISquirrelState>>('Squirrel DataAccess Reducers');

@NgModule({
  imports: [StoreModule.forFeature(FEATURE_STATE, REDUCER_TOKEN)],
  providers: [
    [
      ReducerService,

      {
        provide: REDUCER_TOKEN,
        deps: [ReducerService],
        useFactory: (service: ReducerService) => service.reducers
      },
      {
        provide: USER_PROVIDED_EFFECTS,
        useValue: getEffectTokens(),
        multi: true
      }
    ]
  ]
})
export class FeatureSquirrelDataAccessModule {
  constructor() {}
}
